import React, { useMemo } from 'react';
import { useAtom } from 'jotai';
import { ImageLoader } from '@icecreamsocial/components';
import PopsicleLoader from '../../presentational/PopsicleLoader';
import { campaignAtom, sharedAtom } from '../../../shared/atoms';

/**
 * @description
 * Displays the hero image.  Image changes depending on if `store.shared` has been set to true
 *
 * @usage
 * `<Hero />`
 */
export const Hero = () => {
	const [{ campaign }] = useAtom(campaignAtom);
	const [shared] = useAtom(sharedAtom);

	const offerImageURL = `${process.env.BASE_IMG_URL}/${campaign?.offerImage}`;
	const thankYouImageURL = `${process.env.BASE_IMG_URL}/${campaign?.thankYouImage}`;
	const hero = useMemo(() => (!shared ? offerImageURL : thankYouImageURL), [
		shared,
		offerImageURL,
		thankYouImageURL,
	]);

	return (
		<ImageLoader
			key={hero}
			srcList={hero}
			backgroundColor='body'
			elWidth='100%'
			elMinWidth='50%'
			elMinHeight='240px'
			alignSelf='stretch'
			overflow='hidden'
			position={['fixed', 'relative']}
			style={{
				objectFit: 'cover',
				objectPosition: '50% 50%',
			}}
			loader={() => <PopsicleLoader margin='auto' />}
		/>
	);
};
